import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  message: string;
  title: string;

  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  ngOnInit(): void {
    this.message = this.modalData.message
    this.title = this.modalData.title
    if (this.modalData.delay) {
      setTimeout(() => {
        this.dialogRef.close()
      }, this.modalData.delay);
    }
  }

  actionFunction() {
    this.dialogRef.close();
  }

  closeModal() {
    this.dialogRef.close();
  }

}
